var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAerial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 1240",
    width: 1240,
    height: 1240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1240,
    height: 1240,
    rx: 238,
    ry: 238,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238 618 H 960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 618 C 650 618, 600 415, 775 415 L 960 415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 618 C 650 618, 600 821, 775 821 L 960 821"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972,
    cy: 415,
    r: 86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972,
    cy: 618,
    r: 86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972,
    cy: 821,
    r: 86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerial);
export default __webpack_public_path__ + "static/media/aerial.9296d47ed3ae458e8ddd088fba6763c0.svg";
export { ForwardRef as ReactComponent };